import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { OverChargeClaimItem } from '@/views/screens/Claims/types';

import { getOCClaimNextPage } from '../utils/get-next-page';

export const PAGE_SIZE_DEFAULT = 10;

export interface GetOCClaimItemsRequestParams {
  fbOcKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface OCClaimItemsResponse {
  data: OverChargeClaimItem[];
  nextPage?: number;
  totalRows: number;
  totalBilledAmount: number;
  totalPaidAmount: number;
  totalCorrectCharges: number;
  totalOverchargeAmount: number;
  totalRecoveryAmount: number;
}

export const getOCClaimItemsAPI = (params: GetOCClaimItemsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      fbOcKey: params.fbOcKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || PAGE_SIZE_DEFAULT,
      sortColumn: params.sortColumn || 'itemID',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.OVERCHARGE_CLAIM}/GetClaimItems`,
  });
};

export const fetchOCClaimItems = async (params: GetOCClaimItemsRequestParams): Promise<OCClaimItemsResponse> => {
  const response: AxiosResponse<OCClaimItemsResponse> = await getOCClaimItemsAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize || PAGE_SIZE_DEFAULT);
  const pageData = data.data ?? [];

  return {
    ...data,
    nextPage: getOCClaimNextPage(Number(params.pageIndex), pageSize, Number(data.totalRows ?? 0), pageData.length),
  };
};
